module.exports = __webpack_public_path__ + "img/multiple-account-outline.39b897a6.svg";